import React, { useEffect } from "react";

// import sections
import HeroSection from "./sections/HeroSection";
import AboutMissionSection from "./sections/AboutMissionSection";
import AboutStorySection from "./sections/AboutStorySection";
import AboutExistsSection from "./sections/AboutExistsSection";
import AboutWorkSection from "./sections/AboutWorkSection";
import AboutValuesSection from "./sections/AboutValuesSection";
import AboutTeamSection from "./sections/AboutTeamSection";
import FinalCtaSection from "../home/sections/FinalCtaSection";

const About = ({ title }) => {
  useEffect(() => {
    const original = document.title;
    document.title = title + " | " + original;
    return () => {
      document.title = original;
    };
  }, [title]);

  return (
    <div>
      <HeroSection />
      <AboutMissionSection />
      <AboutStorySection />
      <AboutExistsSection />
      <AboutWorkSection />
      <AboutValuesSection />
      <AboutTeamSection />
      <FinalCtaSection />
    </div>
  );
};

export default About;
